import PageShell from "@/components/PageShell";
import { Palmares } from "@/components/landing/Palmares";

export default function PalmaresPage() {
  return (
    <PageShell crumbs={[{ label: "Palmarés" }]}>
      <Palmares />
    </PageShell>
  );
}
